import { useEffect, useState, useRef } from 'react';

const useScroll = () => {
    const [isScrolling, setIsScrolling] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            // Clear any existing timeout
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            // Set scrolling state to true
            setIsScrolling(true);

            // Set a new timeout to set scrolling state to false after 1 second
            timeoutRef.current = setTimeout(() => {
                setIsScrolling(false);
            }, 500);
        };

        // Add the event listener to the window
        window.addEventListener('scroll', handleScroll, true);

        // Cleanup function to remove the event listener and clear timeout
        return () => {
            window.removeEventListener('scroll', handleScroll, true);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return isScrolling;
};

export default useScroll;